const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.' , sortable: false, thStyle: 'width: 5%', },
    { key: 'is_use', label: 'Status', thStyle: 'width: 15%'},
    { key: 'name', label: 'Name' },
    { key: 'host', label: 'Host' },
    { key: 'os_type', label: 'Version - OS' , thStyle: 'width: 15%'},
    { key: 'ip_addr', label: 'IP' , thStyle: 'width: 20%'},
    { key: 'created_at', label: 'Installed', thStyle: 'width: 10%' },
    // { key: 'select', label: 'Check' , thStyle: 'width: 10%'}
  ],
  KO : [
    { key: 'id', label: 'No.' , sortable: false, thStyle: 'width: 5%', },
    { key: 'is_use', label: '상태', thStyle: 'width: 15%'},
    { key: 'name', label: '이름' },
    { key: 'host', label: '호스트' },
    { key: 'os_type', label: '버전 - 운영체제' , thStyle: 'width: 15%'},
    { key: 'ip_addr', label: 'IP주소' , thStyle: 'width: 20%'},
    { key: 'created_at', label: '설치일', thStyle: 'width: 10%' },
    // { key: 'select', label: '선택' , thStyle: 'width: 10%'}
  ],
  JP: [
    { key: 'id', label: 'No.' , sortable: false, thStyle: 'width: 5%', },
    { key: 'is_use', label: 'ステータス', thStyle: 'width: 15%'},
    { key: 'name', label: '名前' },
    { key: 'host', label: 'ホスト' },
    { key: 'os_type', label: 'バージョン - OS' , thStyle: 'width: 15%'},
    { key: 'ip_addr', label: 'IP' , thStyle: 'width: 20%'},
    { key: 'created_at', label: 'インストール済み', thStyle: 'width: 10%' },
    // { key: 'select', label: 'チェック' , thStyle: 'width: 10%'}
  ]
}

const _i18n_info = {
  done : {
    EN: `all request done`,
    KO: `all request done`,
    JP: `すべてのリクエストが完了しました`
  }
}

const _i18n_warning = {
  all_cmd : {
    EN: `the cmd is wrong`,
    KO: `the cmd is wrong`,
    JP: `コマンドが間違っています`
  }
}

const _i18n_error = {
  agent_check : {
    EN: `Agent Not Define!`,
    KO: `Agent Not Define!`,
    JP: `エージェントが定義されていません`
  },
  load_failed : {
    EN: `The server does not exist or is not responding`,
    KO: `The server does not exist or is not responding`,
    JP: `サーバーが存在しないか、応答していません`
  }
}

const _i18n_data = {
  i18n_fields,
  _i18n_info,
  _i18n_warning,
  _i18n_error
}

export default _i18n_data